import { DndContext } from "@dnd-kit/core";
import { restrictToWindowEdges, snapCenterToCursor } from "@dnd-kit/modifiers";

import { customRectangleIntersection } from "./collisions/customRectangleIntersection/customRectangleIntersection";
import { restrictDragDirectionOfSpanControls } from "./modifiers/restrictDragDirectionOfSpanControls/restrictDragDirectionOfSpanControls";
import { restrictSpanExtensionControlToEmptyCells } from "./modifiers/restrictSpanExtensionControlToEmptyCells/restrictSpanExtensionControlToEmptyCells";
import { snapHandleToGrid } from "./modifiers/snapHandleToGrid/snapHandleToGrid";

import type { DndContextProps } from "@dnd-kit/core";

export const DndKitContextDefaults = ({
  children,
  ...props
}: DndContextProps) => {
  return (
    <DndContext
      collisionDetection={customRectangleIntersection}
      modifiers={[
        snapCenterToCursor,
        snapHandleToGrid,
        restrictToWindowEdges,
        restrictDragDirectionOfSpanControls,
        restrictSpanExtensionControlToEmptyCells,
      ]}
      {...props}
    >
      {children}
    </DndContext>
  );
};
